export const config = {
    app: process.env.REACT_APP_GANON_APP,
    env: process.env.REACT_APP_ENVIRONMENT,
    token: process.env.REACT_APP_GANON_TOKEN,
    url: process.env.REACT_APP_GANON_URL,
};
